export default __webpack_public_path__ + "static/media/flipflops@3x.c53d27e8.png";